import { Link } from "wouter";
import "@/components/marketing/marketing.css";
export default function Footer() {
  return (
    <footer className="growth">
      <div className="footer">
        <div className="wrap">
          <Link href="/" className="brand">
            Better Systems AI
          </Link>
          <p className="small" style={{ marginTop: 8 }}>
            Practical systems. Less busywork. Phoenix, Arizona.
          </p>
          <div className="footerlinks">
            <Link href="/services">What we do</Link>
            <Link href="/work">Our work</Link>
            <Link href="/about">About</Link>
            <Link href="/ai-sales">Free AI plan</Link>
            <Link href="/contact">Contact</Link>
            <a href="mailto:rodolfo@bettersystems.ai">
              rodolfo@bettersystems.ai
            </a>
          </div>
          <div className="small">
            © {new Date().getFullYear()} Better Systems AI.{" "}
            <Link href="/privacy">Privacy</Link>
          </div>
          <div className="small" style={{ marginTop: 15 }}>
            Soil Seed & Water app:{" "}
            <Link href="/privacy/myorganicsoil">Privacy</Link> ·{" "}
            <Link href="/terms/myorganicsoil">Terms</Link> ·{" "}
            <Link href="/support/myorganicsoil">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
